// Shared segmented primitive — a DIRECT choice (never a cyclic multi-click toggle).
// One visual language reused by Presenze and Attività; the caller owns the write.
export function Segmented({ options, value, onSelect, disabled, testId, size = "md" }) {
  const box = size === "sm" ? "h-7" : "h-8";
  const cell = size === "sm" ? "w-7" : "w-8";
  return (
    <div className={`shrink-0 flex rounded-lg border border-[#E5DEC9] overflow-hidden ${box}`} data-testid={testId}>
      {options.map((o, idx) => {
        const sel = (value || options[0].v) === o.v;
        const cls = sel ? o.selCls : "bg-white text-[#5F6B64] hover:bg-[#F0EAE1]";
        return (
          <button key={o.v} type="button" title={o.label} disabled={disabled}
            data-testid={testId ? `${testId}-${o.v}` : undefined}
            onClick={() => !disabled && onSelect(o.v)}
            className={`${cell} flex items-center justify-center text-sm font-semibold transition-colors ${idx > 0 ? "border-l border-[#E5DEC9]" : ""} ${disabled ? "opacity-60 cursor-default" : ""} ${cls}`}>
            {o.node}
          </button>
        );
      })}
    </div>
  );
}
